<script setup lang="ts">
import { Toaster } from '@/components/shadcn/ui/sonner'
import 'vue-sonner/style.css'
import { onMounted } from 'vue';
import { toast } from 'vue-sonner';
import { useScores } from './store/datasources/scores';
import { useSongStore } from './store/datasources/song';
import { useChartData } from './store/chartStats.ts';
onMounted(async () => {
  checkUpdate();
  const userAgent = navigator.userAgent;
  console.log("User Agent:", userAgent);
})
const ScoreStore = useScores()
const SongStore = useSongStore()
const ChartStore = useChartData()
const checkUpdate = async () => {
  if (SongStore.checkSongUpdate()) {
    console.log("正在尝试更新歌曲源");
    await SongStore.updateSongFromAPI(false)
  }
  let needReSync = ScoreStore.checkScoreVersion()
  if (needReSync) {
    toast.warning("本地数据源结构与当前版本不一致,为了避免错误，我们对本地的数据源进行了重置，请根据需要重新进行获取。")
  }
  if (ChartStore.checkNeedUpdate()) {
    ChartStore.updateData();
  }
}
</script>

<template>
  <Toaster />
  <RouterView />
</template>

<style scoped></style>
